'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxUi = require('redux-ui');

var _reduxUi2 = _interopRequireDefault(_reduxUi);

var _reduxFormSubmitActions = require('actions/reduxFormSubmitActions');

var _messageActions = require('actions/messageActions');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    App: {
        displayName: 'App'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/Users/gareth.chou/Documents/GAdventures/g-rex/app/containers/App.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var App = _wrapComponent('App')((_dec = (0, _reduxUi2.default)({
    state: {
        checkinDocumentsIsVisible: false,
        reminderModalIsVisible: false,
        navModalIsVisible: false,
        passengersDropdownIsVisisble: false,
        reminderModalData: {
            customerId: null,
            checkinUrl: null,
            recipientEmail: null
        },
        LOIModalIsVisible: false,
        flight424Error: false
    }
}), _dec(_class = function (_PureComponent) {
    (0, _inherits3.default)(App, _PureComponent);

    function App() {
        (0, _classCallCheck3.default)(this, App);
        return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
    }

    (0, _createClass3.default)(App, [{
        key: 'render',
        value: function render() {
            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_components2.CompleteBar, null),
                _react3.default.createElement(_components2.Fireworks, null),
                _react3.default.createElement(_components2.UserComplete, null),
                _react3.default.createElement(_components2.ReminderModal, {
                    onSubmit: (0, _reduxFormSubmitActions.onSubmitActions)(_messageActions.MESSAGE_POST_REQUESTED, _messageActions.MESSAGE_POST_SUCCEEDED, _messageActions.MESSAGE_POST_FAILED),
                    initialValues: this.props.ui.reminderModalData }),
                this.props.children,
                _react3.default.createElement(_components2.BrandedFooter, null)
            );
        }
    }]);
    return App;
}(_react2.PureComponent)) || _class));

App.propTypes = {
    children: _propTypes2.default.object.isRequired
};

exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/containers/App.js
// module id = 1354
// module chunks = 0